module.exports = __webpack_public_path__ + "static/media/2024进度条-1_02.0709dfeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/2024进度条-1_02.jpg
// module id = 1058
// module chunks = 0